import React from 'react'
import styled from 'styled-components/macro'

const ButtonStyle = styled.button`
	display: inline-block;
	box-sizing: border-box;
	padding: 15px 26px;
	font-family: inherit;
	font-size: 17px;
	font-weight: 600;
	line-height: 1.2;
	cursor: pointer;
	border: 2px solid transparent;
	border-radius: ${props => props.theme.radius};
	outline: none;
	background: none;
	color: ${props => props.theme.navyColor};
	text-decoration: none;
	text-align: center;
	transition: background 0.15s ease, border-color 0.15s ease;
	&:hover {
		background: ${props => props.theme.softColor};
	}
	&:focus-visible {
		box-shadow: 0 0 0 3px rgba(1, 72, 124, 0.25);
	}

	&.filled {
		color: #fff;
		background: ${props => props.theme.accentColor};
		&:hover {
			background: ${props => props.theme.accentDarkColor};
		}
	}

	&.outline {
		border-color: ${props => props.theme.navyColor};
		&:hover {
			background: ${props => props.theme.softColor};
		}
	}

	&.small {
		padding: 8px 14px;
		font-size: 15px;
	}

	&.disabled {
		pointer-events: none;
		color: #fff;
		background: #b7c0c6;
		border-color: transparent;
	}
`

const Button = ({ onClick, variant, disabled, ...props }) => {
	const handleClick = e => {
		if (typeof onClick === 'function') {
			e.preventDefault()
			e.stopPropagation()
			onClick(e)
		}
	}
	return (
		<ButtonStyle
			className={disabled ? 'disabled' : variant}
			onClick={handleClick}
			disabled={disabled}
			{...props}
		/>
	)
}

export default Button
